export function getdata() {
	let obj = {
		headData: [{
			title: '购销身份',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '对方纳税人名称',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '纳税人识别号',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '对应蓝票数电票号码',
			prop: 'tes3',
			width: '160',
			issort: true
		}, {
			title: '对应蓝票数发票代码',
			prop: 'tes3',
			width: '160',
			issort: true
		}, {
			title: '对应蓝票发票号码',
			prop: 'tes3',
			width: '160',
			issort: true
		}, {
			title: '红字通知单编号',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '未税金额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '发票税额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '冲红原因',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '价税合计',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '确认单状态',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '备注',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '是否已开具',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '蓝票抵扣状态',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '蓝票入账状态',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '申请日期',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '录入方身份',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '操作',
			prop: 'cz',
			width: '150',
			custom: true,
			fixed: 'right',
		}],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 3,
			paginationkey: 0
		},

		headDatajl: [{
			title: '对方纳税人名称',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '纳税人识别号',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '数电票号码',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '价税合计',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '对应蓝票数票号码',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '未税金额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '发票税额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '开票日期',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '操作',
			prop: 'cz',
			width: '150',
			custom: true,
			fixed: 'right',
		}],
		//页码
		paginationjl: {
			pageNum: 1,
			pageSize: 50,
			total: 3,
			paginationkey: 0
		},
	}
	return obj
}
